import { useBooking } from 'hooks';
import { useMemo } from 'react';
import { Reason } from 'types';

const useLimitedVisitTypeReasonsFlag = (reasons: Reason[]) => {
    const { booking } = useBooking();

    const { videoReasonsOnly, inOfficeReasonsOnly, oneVisitTypeOnly } = useMemo(() => {
        if (reasons.length === 0) {
            return {
                videoReasonsOnly: undefined,
                inOfficeReasonsOnly: undefined,
                oneVisitTypeOnly: undefined,
            };
        }

        return {
            videoReasonsOnly: reasons.every((reason) => !reason.is_in_person),
            inOfficeReasonsOnly: reasons.every((reason) => reason.is_in_person),
            // When only a single visit type is available for the selected reason
            oneVisitTypeOnly: reasons.filter((reason) => reason.name === booking.reason?.name).length === 1,
        };
    }, [reasons, booking.reason, reasons.length]);

    return { videoReasonsOnly, inOfficeReasonsOnly, oneVisitTypeOnly };
};

export { useLimitedVisitTypeReasonsFlag };
